import React, { ChangeEvent } from 'react';

import Text from 'components/Text';
import { Row, Column } from 'components/Layout/Grid';
import FloatingLabel from 'components/FloatingLabel';

import attachmentIcon from 'img/icon-anexo.svg';
import { FileTypesAccept } from 'pages/OpenProtocol/interface';
import { AttachmentSimpleProps } from './interface';

import { FilesInput } from './styles';

export const AttachmentSimple: React.FC<AttachmentSimpleProps> = (props) => {
  const { files, setFiles } = props;

  const addFile = (e: ChangeEvent<any>) => {
    const fileTypes: string[] = FileTypesAccept;
    const filesTarget: Array<any> = [...e.target.files];

    filesTarget.forEach((file) => {
      fileTypes.includes(file.type) &&
        setFiles((fileOld) => [...fileOld, file]);
    });

    e.target.value = "";
  };

  const removeFile = (id: number) => {
    const _files: Array<any> = files;

    _files.splice(id, 1);

    return setFiles([..._files]);
  };

  return (
    <Column className="mt-5">
      <Row className="align-center">
        <img src={attachmentIcon} alt="" />
        <Text className="ml-1 color-blue-gray" size={12}>
          Anexar Arquivos
        </Text>

        <FilesInput
          onChange={addFile}
        />
      </Row>
      <Row className="mt-1 align-center align-sm-none flex-sm-column  ">
        <label className="button outline" htmlFor="openProtocolFilesSimple">
          <Text className="px-2 color-primary font-bold">
            Selecionar Arquivo
          </Text>
        </label>
        <Row className="ml-2 ml-sm-0 my-sm-2 align-center flex-wrap word-break">
          {files.map((file, _) => (
            <FloatingLabel
              key={_}
              label={file.name}
              index={_}
              onRemove={removeFile}
              uri={file.uri}
            />
          ))}
        </Row>
      </Row>
    </Column>
  );
};